"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["question", "unique", "test", "value"],

  mixins: [require("../../mixins/HasReferences.js")],

  data: function data() {
    return {
      showMore: false
    };
  },


  computed: {
    rangeClass: function rangeClass() {
      var status = this.statusClass;

      return status ? status + " range-status" : "range-status transparent-border";
    },


    /**
     * Show reference value
     * @returns {boolean}
     */
    showReferenceValue: function showReferenceValue() {
      return this.test.type.template_type !== "questionnaire";
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/tests/Question.vue
// module id = RRAT
// module chunks = 0 1